var _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuTrade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 1.66666C8.63153 1.66666 5.83331 4.46488 5.83331 7.91666C5.83331 11.3684 8.63153 14.1667 12.0833 14.1667C15.5351 14.1667 18.3333 11.3684 18.3333 7.91666C18.3333 4.46488 15.5351 1.66666 12.0833 1.66666Z",
    fill: "url(#paint0_linear_895_120377)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_895_120377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91669 5.83334C4.46491 5.83334 1.66669 8.63156 1.66669 12.0833C1.66669 15.5351 4.46491 18.3333 7.91669 18.3333C11.3685 18.3333 14.1667 15.5351 14.1667 12.0833C14.1667 8.63156 11.3685 5.83334 7.91669 5.83334Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_895_120377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 5,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91669 5.83334C4.46491 5.83334 1.66669 8.63156 1.66669 12.0833C1.66669 15.5351 4.46491 18.3333 7.91669 18.3333C11.3685 18.3333 14.1667 15.5351 14.1667 12.0833C14.1667 8.63156 11.3685 5.83334 7.91669 5.83334Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_895_120377)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_895_120377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2.5C7.79822 2.5 5 5.29822 5 8.75C5 12.2018 7.79822 15 11.25 15C14.7018 15 17.5 12.2018 17.5 8.75C17.5 5.29822 14.7018 2.5 11.25 2.5Z",
    fill: "url(#paint1_linear_895_120377)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_895_120377",
    x: 0.0000202656,
    y: 4.16668,
    width: 15.8333,
    height: 15.8333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 0.833333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_895_120377"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_895_120377",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_895_120377",
    x: 1.66667,
    y: -0.833333,
    width: 19.1667,
    height: 19.1667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667,
    result: "effect1_foregroundBlur_895_120377"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_895_120377",
    x1: 5.83331,
    y1: 14.1667,
    x2: 18.3333,
    y2: 14.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27A2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_895_120377",
    x1: 5,
    y1: 15,
    x2: 17.5,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27A2F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTrade);
export default __webpack_public_path__ + "static/media/menu-trade.ce8a0dfb9ffa96a09c06dbbb9123d9c3.svg";
export { ForwardRef as ReactComponent };